import { createAsyncThunk } from "@reduxjs/toolkit"
import _ from "lodash"
import { sendAsync } from "../../../app/applicationSlice"
import { RootThunkApi } from "../../../app/store"
import * as U from "../../../models/user"
import { User } from "../../../models/user"
import * as SU from "../../../services/personalDetail"

export const getUserProfile = createAsyncThunk<User, void, RootThunkApi<User>>(
  "user/getUserProfile",
  async (_, api) => {
    return sendAsync(SU.getUserProfile(), api).then((data: unknown) =>
      U.fromJson(data)
    )
  }
)

export const getUserProfileList = createAsyncThunk<any, any, RootThunkApi>(
  "user/getUserProfileList",
  async (params, api) => {
    return sendAsync(SU.getUserProfileList(params), api).then((data) => {
      return data?.records
    })
  }
)

export const createOrUpdateUser = createAsyncThunk<
  void,
  SU.CreateUserParams,
  RootThunkApi<void>
>("user/createOrUpdateUserStatus", async (params, api) => {
  return sendAsync(SU.createOrUpdateUser(params), api).then(() => {
    // do nothing.
  })
})

export const saveSetting = createAsyncThunk<void, any, RootThunkApi>(
  "user/createOrUpdateUserStatus",
  async (body, api) => {
    return sendAsync(SU.saveSettingLable(body), api).then(() => {
      // do nothing.
    })
  }
)

export const setShopType = createAsyncThunk<
  void,
  SU.shopTypeBody,
  RootThunkApi
>("user/setShopType", async (body, api) => {
  return sendAsync(SU.setShopType(body), api)
})

export const getShopType = createAsyncThunk<
  any,
  SU.shopTypeParams,
  RootThunkApi
>("user/setShopType", async (params, api) => {
  return sendAsync(SU.getShopType(params), api)
})

export const changePassword = createAsyncThunk<
  any,
  SU.changePasswordBody,
  RootThunkApi<void>
>("user/changePassword", async (body, api) => {
  return sendAsync(SU.getChangePasswordSave(body), api).then(() => {
    // do nothing.
  })
})
